var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1833_67695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 32.8033L20 25.3033L16.4645 28.8388V32.3744L12.9289 35.9099L10.2773 29.7227L4.0901 27.0711L7.62563 23.5355H11.1612L14.6967 20L4.0901 12.9289L7.62563 9.3934L20.8839 13.8128L26.1872 8.50951C26.8904 7.80625 27.8443 7.41116 28.8388 7.41116C29.8334 7.41116 30.7872 7.80625 31.4905 8.50951C32.1937 9.21277 32.5888 10.1666 32.5888 11.1612C32.5888 12.1557 32.1937 13.1096 31.4905 13.8128L26.1872 19.1161L26.4818 20",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 26.675C27.6724 26.6207 27.6094 26.5502 27.566 26.4692C27.5226 26.3882 27.5 26.2989 27.5 26.2083V23.5833C27.5 23.4286 27.5658 23.2803 27.6831 23.1709C27.8003 23.0615 27.9592 23 28.125 23H36.875C37.0408 23 37.1997 23.0615 37.3169 23.1709C37.4342 23.2803 37.5 23.4286 37.5 23.5833V26.1821C37.4997 26.272 37.4771 26.3607 37.434 26.4411C37.3909 26.5216 37.3285 26.5916 37.2516 26.6458L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30L27.75 33.325C27.6724 33.3793 27.6094 33.4498 27.566 33.5308C27.5226 33.6118 27.5 33.7011 27.5 33.7917V36.4167C27.5 36.5714 27.5658 36.7197 27.6831 36.8291C27.8003 36.9385 27.9592 37 28.125 37H36.875C37.0408 37 37.1997 36.9385 37.3169 36.8291C37.4342 36.7197 37.5 36.5714 37.5 36.4167V33.8179C37.4999 33.7277 37.4775 33.6388 37.4344 33.5581C37.3913 33.4773 37.3287 33.407 37.2516 33.3527L32.5 30Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1833_67695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.26c8643ba020bd1ef2f87efca8e98bc4.svg";
export { ForwardRef as ReactComponent };